/* ============================================
   DEUTSCHE ÜBERSETZUNGEN
   ============================================ */

export const de = {
  // Spielzustände
  matchStates: {
    notStarted: 'Nicht gestartet',
    firstHalf: '1. Halbzeit',
    halfTime: 'Halbzeit',
    secondHalf: '2. Halbzeit',
    extraTimeFirstHalf: 'Verlängerung 1. Halbzeit',
    extraTimeHalfTime: 'Verlängerungspause',
    extraTimeSecondHalf: 'Verlängerung 2. Halbzeit',
    penalties: 'Elfmeterschießen',
    finished: 'Beendet',
    postponed: 'Verschoben',
    cancelled: 'Abgesagt',
    interrupted: 'Unterbrochen',
  },

  // Ereignisse
  events: {
    goal: 'Tor',
    yellowCard: 'Gelbe Karte',
    redCard: 'Rote Karte',
    substitution: 'Auswechslung',
    corner: 'Ecke',
    freeKick: 'Freistoß',
    penalty: 'Elfmeter',
    offside: 'Abseits',
    injury: 'Verletzung',
    var: 'VAR',
    shotOnTarget: 'Schuss aufs Tor',
    shotOffTarget: 'Schuss daneben',
    throwin: 'Einwurf',
    dangerousAttack: 'Gefährlicher Angriff',
    attack: 'Angriff',
    possession: 'Ballbesitz',
    sixMeters: '6-Meter-Raum',
    goalKick: 'Abstoß',
    blockedShot: 'Geblockter Schuss',
    penaltyUnconfirmed: 'Elfmeter (unbestätigt)',
    penaltyMissed: 'Elfmeter verschossen',
    goalNotification: 'Tor-Benachrichtigung',
    kickoff: 'Anstoß',
    secondHalfKickoff: 'Anstoß 2. Halbzeit',
    ballLost: 'Ball verloren',
    ballRecovered: 'Ball zurückerobert',
    ownGoal: 'Eigentor',
    matchStart: 'Beginn',
    matchEnd: 'Ende',
    halfTimeScore: 'Halbzeitstand',
    cardConfirmed: 'Karte bestätigt',
    extraTimeEnded: 'Verlängerung beendet',
    penaltyEnded: 'Elfmeter beendet',
    penaltyShootout: 'Elfmeterschießen',
    penaltyShootoutMissed: 'Elfmeter verschossen (Schießen)',
  },

  // Ballbesitzanzeigen
  possession: {
    home: 'Heimballbesitz',
    away: 'Auswärtsballbesitz',
    attack: 'Angriff',
    dangerousAttack: 'Gefährlicher Angriff',
  },

  // Benutzeroberfläche
  ui: {
    home: 'Heim',
    away: 'Auswärts',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    connecting: 'Verbinde...',
    loading: 'Laden...',
    noMatch: 'Kein Spiel ausgewählt',
    selectMatch: 'Spiel auswählen',
  },

  // Nachspielzeit
  addedTime: {
    label: 'Nachspielzeit',
    minute: 'Min',
    minutes: 'Min',
  },

  // Benachrichtigungen
  notifications: {
    matchStarted: 'Spielbeginn',
    matchEnded: 'Das Spiel ist beendet',
    halfTimeStarted: 'Halbzeit',
    secondHalfStarted: 'Wiederaufnahme des Spiels',
    matchAboutToStart: 'Das Spiel beginnt gleich',
    matchAboutToResume: 'Das Spiel wird gleich fortgesetzt',
    penaltiesInProgress: 'Das Schießen läuft',
    // Zentrierte Ereignisbenachrichtigungen
    kickoffTitle: 'Anstoß',
    kickoffSubtitle: 'Das Spiel hat begonnen!',
    goalTitle: 'Tor! Tor! Tor!',
    yellowCardTitle: 'Gelbe Karte',
    yellowCardSubtitle: 'Ein Spieler hat eine gelbe Karte erhalten',
    redCardTitle: 'Rote Karte',
    redCardSubtitle: 'Ein Spieler hat eine rote Karte erhalten',
    injuryTitle: 'Verletzung',
    injurySubtitle: 'Ein Spieler ist verletzt',
    substitutionTitle: 'Auswechslung',
    substitutionSubtitle: 'Wechsel im Gange',
    varTitle: 'VAR läuft',
    varSubtitle: 'Der Schiedsrichter wird eine Entscheidung treffen',
    varCancelledTitle: 'Tor annulliert',
    varCancelledSubtitle: 'Das Tor wurde vom VAR annulliert',
    addedTimeTitle: 'Nachspielzeit',
    addedTimeSubtitle: 'Es werden zusätzliche Minuten gespielt!',
  },

  // Feldanzeigen (GROSSBUCHSTABEN)
  fieldIndicators: {
    possession: 'BALLBESITZ',
    attack: 'ANGRIFF',
    dangerousAttack: 'GEFÄHRLICHER ANGRIFF',
    throwin: 'EINWURF',
    freeKick: 'FREISTOSS',
    dangerousFreeKick: 'GEFÄHRLICHER FREISTOSS',
    corner: 'ECKE',
    goalKick: 'ABSTOSS',
    penalty: 'ELFMETER',
    shotOnTarget: 'SCHUSS AUFS TOR',
    shotOffTarget: 'SCHUSS DANEBEN',
    offside: 'ABSEITS',
    ballLost: 'BALLVERLUST',
  },

  // Countdown
  countdown: {
    hours: 'Std',
    minutes: 'Min',
    seconds: 'Sek',
  },

  // Steuerelemente
  controls: {
    openRadar: 'Radar öffnen',
    reload: 'Neu laden',
    date: 'Datum',
    match: 'Spiel',
    delay: 'Verzögerung (Sekunden)',
    fieldLength: 'Länge (px)',
    fieldWidth: 'Breite (px)',
    fieldColor: 'Feldfarbe',
    language: 'Sprache',
    connectedStatus: 'Verbunden',
    disconnectedStatus: 'Nicht verbunden',
  },
};

